import { useSelector } from '../providers/StoreProvider';

export const useTeams = () => {
  return useSelector(state => state.teams);
};
